import {WarriorClass} from "@/store/level/types";

export class ForceUtils {

    public static getImage(warrClass: WarriorClass): string {
        let n = warrClass.toString().toLowerCase();
        if (n.endsWith('_5') || n.endsWith('_4') || n.endsWith('_3') || n.endsWith('_2')) {
            n = n.substr(0, n.length - 2);
        }
        return 'g_' + n;
    }

}
